import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import reducers from "../reducers";
import { loadState } from "../containers/localStorage";

let middleware = [thunk];
if (process.env.NODE_ENV !== "production") {
  middleware = [...middleware, logger];
}
const hotels = loadState("hotels") || [];
let selected = loadState("selectedHotel");
const messagesVisibility = loadState("messagesVisibility") || {};
if (selected && !hotels.find(hotel => hotel.hotelId === selected)) {
  selected = undefined;
}
let persistedState = {
  account: {
    phase: "INIT",
    user: loadState("account")
  },
  hotels: {
    phase: "INIT",
    data: hotels,
    selected: selected || (hotels.length > 0 ? hotels[0].hotelId : 0)
  },
  messages: {
    socket: undefined,
    message: "",
    type: "",
    messages: [],
    indicate: false,
    messagesVisibility
  }
};

const store = createStore(
  reducers,
  persistedState,
  applyMiddleware(...middleware)
);

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js